(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      try {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        this.searchModal.close(false);
      } catch(e) {
        console.log("Error closing search modal");
      } 
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mff-product-rec"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    


    const removeText = (records, observer) => {
      for (const record of records) {
        if (record.target.childNodes.length > 1) {
          record.target.childNodes[0].remove();
        }
      }
    };

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }

  // after .loox-rating elements are created, listen for changes
        const looxObserver = new MutationObserver(removeText);
        const ratingsElems = Array.from(document.querySelectorAll('.product-recommendations .loox-rating'));

        ratingsElems.forEach(ratingsElem => {
          looxObserver.observe(ratingsElem, {childList: true})
        });
      })
      .then(() => {
        const decrementQtyElems = Array.from(document.getElementsByClassName("decrement-qty"));
        const incrementQtyElems = Array.from(document.getElementsByClassName("increment-qty"));
        const inputFields = document.querySelectorAll(".quantity input");

        decrementQtyElems.forEach((element, index) => {
          element.addEventListener("click", function() {
            const input = element.nextElementSibling;
            const currentValue = parseInt(input.value);

            if (currentValue > 1) {
              input.value = currentValue - 1;
            } else {
              input.value = 1;
            }
          });
        });

        incrementQtyElems.forEach((element, index) => {
          element.addEventListener("click", function() {
            const input = element.previousElementSibling;
            const currentValue = parseInt(input.value);

            if (currentValue < 98) {
              input.value = currentValue + 1;
            }
          });
        });

        inputFields.forEach((element, index) => {
          element.addEventListener("blur", function() {
            if (element.value === '' || element.value < 1) {
              element.value = 1;
            }
            if (element.value > 99) {
              element.value = 99;
            }
          })
        });

        const forms = document.querySelectorAll(".mff-product-rec-section .meal-card form");
        const cartObject = document.querySelector('cart-drawer');
        forms.forEach(form => {
          form.querySelector("button.add-to-bag").addEventListener("click", async function() {
            const variantId = form.querySelector('.product-variant-id').value;
            const quantityDisplay = form.querySelector('input[name="quantity"]');

            const formData = new FormData();
            formData.append('items[][id]', variantId);
            formData.append('items[][quantity]', quantityDisplay.value);

            if (cartObject) {
              formData.append('sections', cartObject.getSectionsToRender().map(section => section.id));
              formData.append('sections_url', window.location.pathname);
            }

            try {
              const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                body: formData
              });

              if (! response.ok) {
                throw new Error('Failed to add product to cart');
              }

              const data = await response.json();
              cartObject.classList.remove('is-empty')
              cartObject.renderContents(data)
            } catch (err) {
              console.error('Failed to add product to cart:', err);
            }
          });
        });
      })
      .catch(e => {
        console.error(e);
      });
  };
  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
